import { useEffect, useRef } from "react";

// Adds .is-visible to .reveal children when they enter the viewport.
// Also returns a ref you can attach for a single element.
export function useReveal() {
  const ref = useRef(null);

  useEffect(() => {
    const root = ref.current || document;
    const els = root.querySelectorAll(".reveal");
    if (!els.length) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );

    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return ref;
}
